import type { CSSProperties } from 'react';

/** Page shell — cool grey wash so white cards read clearly without harsh contrast */
export const workspacePage: CSSProperties = {
  padding: 16,
  minHeight: 'calc(100vh - 110px)',
  boxSizing: 'border-box',
  background: 'linear-gradient(165deg, #cfd8e6 0%, #dce4ef 38%, #e8eef6 100%)',
};

/** Raised white surface shared by cards and the lead list */
export const workspaceSurface: CSSProperties = {
  background: '#ffffff',
  borderRadius: 14,
  border: '1px solid rgba(15, 23, 42, 0.09)',
  boxShadow:
    '0 1px 0 rgba(255,255,255,0.75) inset, 0 1px 2px rgba(15,23,42,0.04), 0 12px 32px rgba(15,23,42,0.08)',
};

export const workspaceCardHead: CSSProperties = {
  background: 'linear-gradient(180deg, #f4f6fa 0%, #e8ecf4 100%)',
  borderBottom: '1px solid rgba(15, 23, 42, 0.08)',
  fontWeight: 600,
  color: '#0f172a',
};

export const workspaceCardBody: CSSProperties = {
  background: '#fafbfd',
};

export const workspaceInset: CSSProperties = {
  background: 'linear-gradient(180deg, #f1f4f9 0%, #e9eef6 100%)',
  borderBottom: '1px solid rgba(15, 23, 42, 0.07)',
};

export const workspaceAccent = '#1e3a5f';

export const workspaceListSelected: CSSProperties = {
  background: 'linear-gradient(90deg, rgba(30, 58, 95, 0.14) 0%, rgba(30, 58, 95, 0.05) 100%)',
  borderLeft: `4px solid ${workspaceAccent}`,
};

export const workspaceTableWrap: CSSProperties = {
  background: '#ffffff',
  borderRadius: 10,
  border: '1px solid rgba(15, 23, 42, 0.06)',
  overflow: 'hidden',
};
